import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-78a6856a")

_pushScopeId("data-v-78a6856a")
const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "p-d-flex p-ai-center" }
const _hoisted_3 = { class: "p-field-radiobutton" }
const _hoisted_4 = { for: "delta-with-update" }
const _hoisted_5 = { class: "p-field-radiobutton" }
const _hoisted_6 = { for: "delta-with-delete" }
const _hoisted_7 = { class: "p-d-flex p-flex-column  p-mr-2" }
const _hoisted_8 = {
  for: "numberOfLogs",
  class: "kn-material-input-label"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-mt-2" }, {
    content: _withId(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.executionList,
        paginator: true,
        rowsPerPageOptions: [10, 20, 50],
        rows: 10,
        loading: _ctx.loading,
        class: "p-datatable-sm kn-table p-m-1",
        dataKey: "id",
        responsiveLayout: "stack",
        breakpoint: "960px",
        onRowClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showForm($event.data, false))),
        "data-test": "executions-table"
      }, {
        loading: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
        ]),
        header: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", null, [
                _createVNode("div", _hoisted_3, [
                  _createVNode(_component_RadioButton, {
                    id: "delta-with-update",
                    name: "delta",
                    value: true,
                    modelValue: _ctx.schedule.delta,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.schedule.delta = $event)),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('kpi.kpiScheduler.insertAndUpdate')), 1)
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_RadioButton, {
                    id: "delta-with-delete",
                    name: "delta",
                    value: false,
                    modelValue: _ctx.schedule.delta,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.schedule.delta = $event)),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('kpi.kpiScheduler.deleteAndInsert')), 1)
                ])
              ]),
              _createVNode("span", _hoisted_7, [
                _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('kpi.kpiScheduler.numberOfExecutions')), 1),
                _createVNode(_component_InputNumber, {
                  id: "numberOfLogs",
                  inputClass: "kn-material-input",
                  modelValue: _ctx.numberOfLogs,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.numberOfLogs = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_Button, {
                id: "load-button",
                class: "kn-button kn-button--primary",
                label: _ctx.$t('common.load'),
                onClick: _ctx.loadLogExecutionList
              }, null, 8, ["label", "onClick"])
            ])
          ])
        ]),
        default: _withId(() => [
          _createVNode(_component_Column, {
            style: _ctx.executeCardDescriptor.table.columns.style,
            field: "timeRun",
            header: _ctx.$t('kpi.kpiScheduler.timeRun'),
            sortable: true
          }, {
            body: _withId((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.getFormattedDate(slotProps.data.timeRun)), 1)
            ]),
            _: 1
          }, 8, ["style", "header"]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.executeCardDescriptor.columns, (col) => {
            return (_openBlock(), _createBlock(_component_Column, {
              class: "kn-truncated",
              style: _ctx.executeCardDescriptor.table.columns.style,
              field: col.field,
              header: _ctx.$t(col.header),
              key: col.field,
              sortable: true
            }, null, 8, ["style", "field", "header"]))
          }), 128)),
          _createVNode(_component_Column, {
            style: _ctx.executeCardDescriptor.table.iconColumn.style
          }, {
            body: _withId((slotProps) => [
              (slotProps.data.outputPresent)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-download",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.downloadFile(slotProps.data.id))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _: 1
  }))
})